/**
 * Minimap.
 *
 * One slice of the base-view stylesheet. `styles/index.ts` concatenates
 * every slice into the single sheet `injectStyles` mounts — the split is
 * about OWNERSHIP, not about emitting more than one style element.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below
 * is one template literal and a stray backtick terminates it. That has
 * broken the build twice, both times with esbuild pointing at a line ten
 * rows away from the cause. Write class names in plain text.
 */
export default `
/* ── Minimap ──────────────────────────────────────────────────────────────
   Bottom-right. Derived from WorldData at mount (see render/minimap-draw.ts),
   north-locked, so the "N" badge is a fixed label rather than a live compass. */
.bv-minimap {
  position: absolute; bottom: 12px; right: 12px; z-index: 5;
  width: 172px; height: 172px; border-radius: var(--radius-panel); overflow: hidden;
  border: 1px solid var(--line);
  background: rgba(15,9,5,0.86);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 8px 24px rgba(0,0,0,0.5);
  pointer-events: none; backdrop-filter: blur(2px);
}
.bv-minimap[hidden] { display: none; }
.bv-minimap-canvas { display: block; width: 100%; height: 100%; }
/* Decorative bezel (public/ui/minimap-frame.webp, real alpha, 360px = ~2x the
   172px display size). Above the canvas and the N badge, never catches input;
   its transparent centre lets the map show through. Its border is ~7.5% of the
   side, so the badge sits just inside it. */
.bv-minimap::after {
  content: ""; position: absolute; inset: 0; z-index: 2; pointer-events: none;
  background: url("/ui/minimap-frame.webp") center / 100% 100% no-repeat;
}
.bv-minimap-north {
  position: absolute; top: 15px; left: 17px; z-index: 1;
  font: 700 11px var(--font-display); color: var(--brass-bright);
  letter-spacing: 0.14em; text-shadow: 0 1px 3px rgba(0,0,0,0.9);
}
@media (max-width: 640px), (max-height: 480px) {
  .bv-minimap { width: 118px; height: 118px; }
  .bv-minimap-north { top: 10px; left: 12px; font-size: 9px; }
}
/* Below 560px the bottom-left action dock (ui/action-bar.ts) is most of the
   screen's width, so the minimap stands on top of it instead of beside it,
   using the height the dock publishes. */
@media (max-width: 560px) {
  .bv-minimap { bottom: calc(20px + var(--bv-ab-dock-h, 0px)); }
}
`;
